<template>
  <v-dialog v-model="dialog" max-width="520" scrollable>
    <v-card class="demo-request" elevation="0">
      <button
        type="button"
        class="demo-request__close"
        aria-label="Закрити"
        @click="close"
      >
        <v-icon size="22">mdi-close</v-icon>
      </button>

      <template v-if="submitted">
        <div class="demo-request__success">
          <span><v-icon color="#fff" size="30">mdi-check</v-icon></span>
          <h2>Дякуємо за заявку!</h2>
          <p>Команда RedFox зв’яжеться з вами та розповість про повну програму.</p>
          <button type="button" @click="close">Продовжити перегляд демо</button>
        </div>
      </template>

      <template v-else>
        <header class="demo-request__header">
          <span><v-icon size="28">mdi-book-open-variant</v-icon></span>
          <div>
            <h2>Залиште свої дані і ми вам зателефонуємо</h2>
          </div>
        </header>

        <div class="demo-request__lesson">
          <small>{{ popupContext.courseName }}</small>
          <strong>{{ popupContext.lessonName }}</strong>
        </div>

        <form class="demo-request__form" @submit.prevent="submit">
          <label>
            <span>Ваше ім’я</span>
            <input v-model.trim="form.name" type="text" autocomplete="name" placeholder="Як до вас звертатися?" required />
          </label>
          <label>
            <span>Телефон</span>
            <input v-model.trim="form.phone" type="tel" autocomplete="tel" placeholder="+380" @input="contactError = ''" />
          </label>
          <label>
            <span>E-mail</span>
            <input v-model.trim="form.email" type="email" autocomplete="email" placeholder="name@example.com" @input="contactError = ''" />
          </label>
          <p v-if="contactError" class="demo-request__error">{{ contactError }}</p>
          <p v-if="requestError" class="demo-request__error">Не вдалося надіслати заявку. Спробуйте ще раз.</p>
          <button class="demo-request__submit" type="submit" :disabled="submitting">
            <v-progress-circular v-if="submitting" color="#fff" indeterminate size="20" width="3" />
            <template v-else>Залишити контакти <v-icon color="#fff" size="20">mdi-arrow-right</v-icon></template>
          </button>
          <button class="demo-request__secondary" type="button" @click="close">Продовжити перегляд демо</button>
        </form>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import DemoRequestService from '@/services/DemoRequestService';
import PopupEventEnum from '@/enums/PopupEventEnum';

export default {
  name: 'DemoRequestPopup',
  props: {
    popupContext: { type: Object, default: () => ({}) },
  },
  data: () => ({
    dialog: true,
    submitted: false,
    submitting: false,
    contactError: '',
    requestError: false,
    form: { name: '', phone: '', email: '' },
  }),
  watch: {
    dialog(value) {
      if (!value) this.emitClose();
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    emitClose() {
      this.$emit('popupEvent', { type: PopupEventEnum.CLOSE_POPUP });
    },
    async submit() {
      if (!this.form.phone && !this.form.email) {
        this.contactError = 'Вкажіть телефон або e-mail.';
        return;
      }
      this.submitting = true;
      this.requestError = false;
      try {
        const context = [
          'demo-cabinet',
          `course: ${this.popupContext.courseName || ''}`,
          `lesson: ${this.popupContext.lessonName || ''}`,
          `lesson_id: ${this.popupContext.lessonId || ''}`,
          window.location.href,
        ].join(' | ');
        await DemoRequestService.create({ ...this.form, location: context.slice(0, 500) });
        this.submitted = true;
      } catch (error) {
        this.requestError = true;
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.demo-request { border: 1px solid var(--theme-border-decorative) !important; border-radius: 20px !important; padding: 30px; position: relative; }
.demo-request__close { align-items: center; background: #f3f5f6; border: 0; border-radius: 9px; display: flex; height: 36px; justify-content: center; position: absolute; right: 18px; top: 18px; width: 36px; }
.demo-request__header { align-items: flex-start; display: flex; gap: 14px; padding-right: 32px; }
.demo-request__header > span { align-items: center; background: var(--theme-banner-background); border-radius: 13px; display: flex; flex: 0 0 auto; height: 52px; justify-content: center; width: 52px; }
.demo-request__header > span::v-deep .v-icon { color: var(--theme-header-background); }
.demo-request h2 { color: #172033; font-size: 22px; line-height: 1.3; margin: 0 0 6px; }
.demo-request__header p, .demo-request__success p { color: #667085; font-size: 14px; line-height: 1.5; margin: 0; }
.demo-request__lesson { background: var(--theme-app-background-accent); border-radius: 11px; display: flex; flex-direction: column; margin: 22px 0; padding: 12px 14px; }
.demo-request__lesson small { color: #7a8592; margin-bottom: 3px; }
.demo-request__lesson strong { color: #172033; }
.demo-request__form { display: flex; flex-direction: column; gap: 14px; }
.demo-request__form label > span { color: #344054; display: block; font-size: 13px; font-weight: 750; margin-bottom: 6px; }
.demo-request__form input { border: 1px solid var(--theme-border-decorative); border-radius: 10px; box-sizing: border-box; min-height: 48px; outline: none; padding: 0 13px; width: 100%; }
.demo-request__form input:focus { border-color: var(--theme-header-background); box-shadow: 0 0 0 3px var(--theme-accent-decorative); }
.demo-request__error { color: #d92d20; font-size: 13px; margin: -4px 0 0; }
.demo-request__submit, .demo-request__success button { align-items: center; background: var(--theme-header-background); border: 0; border-radius: 10px; color: #fff; display: flex; font-weight: 800; gap: 8px; justify-content: center; min-height: 48px; padding: 10px 16px; }
.demo-request__submit:disabled { opacity: .7; }
.demo-request__secondary { background: transparent; border: 0; color: #667085; font-size: 13px; font-weight: 700; padding: 5px; }
.demo-request__success { align-items: center; display: flex; flex-direction: column; padding: 24px 6px 6px; text-align: center; }
.demo-request__success > span { align-items: center; background: var(--theme-header-background); border-radius: 50%; display: flex; height: 58px; justify-content: center; margin-bottom: 16px; width: 58px; }
.demo-request__success button { margin-top: 22px; width: 100%; }
@media (max-width: 600px) { .demo-request { border-radius: 16px !important; padding: 24px 18px; } .demo-request__header { padding-right: 24px; } }
</style>
